// extracted by mini-css-extract-plugin
module.exports = {"loadingText":"LoadingText_loadingText__Uiega","bar":"LoadingText_bar__1rMp2","load-10":"LoadingText_load-10__2btm6","loadingJ":"LoadingText_loadingJ__192Ev"};